/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'SAVE_STATE',
]);



// WEBPACK FOOTER //
// ./src/chat/constants/MessageComposerConstants.js